module.exports = __webpack_public_path__ + "static/media/dimensions-standard.a408bc27.png";